/*
 * <BeCheckBox> -- React wrapper for the .be-checkbox CSS component: the BeOS R5
 * checkbox (recessed well + blue X). Reconstructed from the byte-verified R5
 * libbe.so decompile (rdef_src/libbe_r5/reconstructed/BCheckBox.Draw.match.cpp);
 * see components/checkbox.css for provenance.
 *
 * Renders a real <input type="checkbox"> inside a <label> (semantic, accessible,
 * keyboard-operable). checked/focus/disabled are native states.
 *
 *   <BeCheckBox checked={on} onChange={(e) => set(e.target.checked)}>
 *     Show grid
 *   </BeCheckBox>
 */

import type { ReactNode } from "react";
import { type BeProps, beComponent } from "./create.tsx";
import { pixelText } from "./pixel-text.tsx";

export type BeCheckBoxProps = BeProps<
	"input",
	{
		/** The checkbox label. */
		children?: ReactNode;
	}
>;

/** The ref lands on the <input>, not the <label> -- see create.tsx. */
export const BeCheckBox = beComponent<BeCheckBoxProps, HTMLInputElement>("BeCheckBox", (props, be) => {
	const { children, scale, className, style, type: _type, ...rest } = props;
	const { ref, ...root } = be("be-checkbox");

	return (
		<label {...root}>
			<input type="checkbox" className="be-checkbox__input" ref={ref} {...rest} />
			<span className="be-checkbox__box" />
			{/* outer span keeps the class: it paints the focus underline gradient, and
			    .be-pixel-text must not sit on a background-painting element. */}
			{children != null && <span className="be-checkbox__label">{pixelText(children)}</span>}
		</label>
	);
});
